<template>
  <div class="news_wrapper w">
    <div
      v-if="componentInfo.config.showTitle"
      class="news_title"
    >
      <div class="news_title_name">
        <img
          src="@/assets/icon_newsTitle.svg"
          class="icon"
          alt=""
          style="width: 24px; height: 24px; margin-right: 10px;"
        >
        <span>{{ componentInfo.config.title }}</span>
      </div>
      <NuxtLink to="/article/list">
        <div
          v-if="componentInfo.config.showMore"
          class="news_title_more pointer"
        >
          查看更多<i class="arrows" />
        </div>
      </NuxtLink>
    </div>
    <div class="new_main">
      <NuxtLink
        v-for="item in componentInfo.data"
        :key="item.id"
        :to="'/article/view?id=' + item.id"
        class="news_item"
      >
        <div class="news_cover">
          <img
            class="news_cover_img"
            :src="item.cover"
          >
        </div>
        <div class="news_tag">{{ item.summary }}</div>
        <div class="news_content">
          <div class="news_name tx-ov-2">
            {{ item.title }}
          </div>
          <div class="news_desc tx-ov-2">
            {{ item.summary }}
          </div>
          <div class="new_info_desc">
            <div>{{ item.gmtCreate.slice(0, 10) }}</div>
            <div class="readNum">
              <img
                src="@/assets/readIcon.svg"
                class="icon"
              >
              {{ item.readCount }}
            </div>
          </div>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    componentInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup (props, { emit }) {
    return {}
  }
})
</script>
<style lang="scss" scoped>
.news_wrapper {
  padding: 25px 0px;
}
.news_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  line-height: 22px;
  color: #333;
}
.news_title_name {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;
  img {
    width: 24px;
    height: 24px;
  }
}

.news_title_more {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
}

.new_main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.news_item {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  text-decoration: none;
  color: #333;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
}

.news_cover {
  width: 100%;
  height: 180px;
  overflow: hidden;

  .news_cover_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.news_tag {
  display: inline-block;
  margin: 12px 16px 0;
  color: #3d7fff;
  font-size: 12px;
  border-radius: 4px;
}

.news_content {
  padding: 12px 16px;
}
.news_name {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color:#333;
  -webkit-line-clamp: 1;
}
.news_desc {
  padding-top: 10px;
  font-size: 12px;
  line-height: 18px;
  height: 42px;
  color: #999999;
  line-height: 20px;
}
.new_info_desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
  color: #999999;
  .readNum {
    height: 18px;
    line-height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    .icon {
      width: 16px;
      height:16px;
    }
  }
}
</style>
